import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/userprofile/successImg.png";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import CircularProgress from "@mui/material/CircularProgress";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

const validationSchema = Yup.object({
  first_name: Yup.string().required("First name is required"),
  last_name: Yup.string().required("Last name is required"),
});

export function MatchBasicProfile({ userId }) {
  const [loader, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [fileNames, setFileNames] = useState("Browse");
  const [imagePreviews, setImagePreviews] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);

  console.log(userId);

  // this function is for getting selected file name on text box because we custome that box for browse
  function handleFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      setFileNames(file.name);
    } else {
      setFileNames("Browse");
    }
  }

  const handleImageChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      formik.setFieldValue("profile_pic", file);
      setImagePreviews(URL.createObjectURL(file));
    }
  };

  const handleDocumentChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      formik.setFieldValue("document", file);
      setDocumentPreview(URL.createObjectURL(file));
    }
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance_agent.get(`/Agent/${userId}`);
      const data = response?.data?.data;

      formik.setValues({
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        email: data.email || "",
        mobile: data.mobile || "",
        agency_name: data.agency_name || "",
        profile_pic: null,
        document: null,
        category: "Match Maker",
        about: data.about || "",
        terms_condition: data.terms_condition || "",
        account_number: data.account_number || "",
        ifsc_code: data.ifsc_code || "",
        bank: data.bank || "",
      });

      setImagePreviews(data.profile_pic || null);
      setDocumentPreview(data.document || null);
    } catch (err) {
      toast.error("Failed to load profile data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      agency_name: "",
      profile_pic: null,
      document: null,
      category: "Match Maker",
      about: "",
      terms_condition: "",
      account_number: "",
      ifsc_code: "",
      bank: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        // Append all fields except files
        const formData = new FormData();
        for (const key in values) {
          if (key !== "profile_pic" && key !== "document") {
            formData.append(key, values[key]);
          }
        }

        // Conditionally append images
        // if (imagePreviews.length > 0) {
        //   imagePreviews.forEach((file) => {
        //     formData.append("profile_pic", file); // or profile_pic[] if API expects array
        //   });
        // }

        if (Array.isArray(imagePreviews) && imagePreviews.length > 0) {
          imagePreviews.forEach((file) => {
            formData.append("profile_pic", file); // or profile_pic[] if API expects array
          });
        }

        // Conditionally append document
        if (values.document) {
          formData.append("document", values.document);
        }

        const response = await axiosInstance_agent.put(
          `/Agent/${userId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        console.log("✅ Submitted:", response.data);
        toast.success("Form data successfully Submitted");
        setLoading(false);
        handleOpen();
        // Auto-close modal after 2 seconds
        setTimeout(() => {
          handleClose();
        }, 2000);
        fetchData();
      } catch (error) {
        console.error("❌ Error:", error);
        setLoading(false);
        toast.error("Submission failed. Please try again.");
      }
    },
  });

  return (
    <div className="MatchMainContainer">
      <form onSubmit={formik.handleSubmit}>
        {loader && (
          <div className="loader-overlay">
            <CircularProgress style={{ color: "#f24464" }} />
          </div>
        )}
        <div>
          {/* row1 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">First Name</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="first_name"
                  placeholder="Enter First Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                />
                {formik.touched.first_name && formik.errors.first_name && (
                  <div className="error">{formik.errors.first_name}</div>
                )}
              </div>
            </div>
            <div>
              <div className="match-lableName">Last Name</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="last_name"
                  placeholder="Enter Last Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                />
                {formik.touched.last_name && formik.errors.last_name && (
                  <div className="error">{formik.errors.last_name}</div>
                )}
              </div>
            </div>
          </div>
          {/* row2 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">User Image</div>
              <div className="matchTextbox">
                {/* <label for="fileInput" class="custom-file-label">
                  {imageNames}
                </label> */}
                <label
                  htmlFor="profile_pic_input"
                  className="custom-file-label"
                >
                  {formik.values.profile_pic?.name || "Browse"}
                </label>
                <input
                  type="file"
                  id="profile_pic_input"
                  className="custom-file-input"
                  accept="image/*,application/pdf"
                  onChange={handleImageChange}
                />
                <div className="image-preview-container">
                  {imagePreviews &&
                    (imagePreviews.endsWith(".pdf") ? (
                      <a href={imagePreviews} target="_blank" rel="noreferrer">
                        View PDF
                      </a>
                    ) : (
                      <a href={imagePreviews} target="_blank" rel="noreferrer">
                        <img
                          src={imagePreviews}
                          alt="Preview"
                          className="image-preview"
                        />
                      </a>
                    ))}
                </div>
              </div>
            </div>
            <div>
              <div className="match-lableName">Email</div>
              <div className="matchTextbox">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  disabled
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error">{formik.errors.email}</div>
                )}
              </div>
            </div>
          </div>
          {/* row3 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Mobile Number</div>
              <div className="matchTextbox">
                <input
                  type="number"
                  name="mobile"
                  onChange={formik.handleChange}
                  value={formik.values.mobile}
                  maxLength={10}
                  disabled
                />
                {formik.touched.mobile && formik.errors.mobile && (
                  <div className="error">{formik.errors.mobile}</div>
                )}
              </div>
            </div>
            <div>
              <div className="match-lableName">Agency Name</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="agency_name"
                  onChange={formik.handleChange}
                  value={formik.values.agency_name}
                />
              </div>
            </div>
          </div>
          {/* row4 */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Aadhar or Pancard Document</div>
              <label htmlFor="document_input" className="custom-file-label">
                {formik.values.document?.name || "Browse"}
              </label>
              <input
                type="file"
                id="document_input"
                className="custom-file-input"
                accept="image/*,application/pdf"
                onChange={handleDocumentChange}
              />
              {documentPreview && (
                <div className="mt-2">
                  {documentPreview.endsWith(".pdf") ? (
                    <a href={documentPreview} target="_blank" rel="noreferrer">
                      View Document
                    </a>
                  ) : (
                    <address
                      href={documentPreview}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={documentPreview}
                        alt="Document Preview"
                        className="image-preview"
                      />
                    </address>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* row 5  */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">About</div>
              <div className="matchTextbox">
                <textarea
                  name="about"
                  onChange={formik.handleChange}
                  value={formik.values.about}
                  rows={4}
                />
                {formik.touched.about && formik.errors.about && (
                  <div className="error">{formik.errors.about}</div>
                )}
              </div>
            </div>
            <div>
              <div className="match-lableName">Terms & Conditions</div>
              <div className="matchTextbox">
                <textarea
                  name="terms_condition"
                  onChange={formik.handleChange}
                  value={formik.values.terms_condition}
                  rows={4}
                />
              </div>
            </div>
          </div>
          {/* row 6  */}
          <div className="MatchSubcontainer">
            <div>
              <div className="match-lableName">Bank Account Number</div>
              <div className="matchTextbox">
                <input
                  type="number"
                  name="account_number"
                  onChange={formik.handleChange}
                  value={formik.values.account_number}
                />
                {formik.touched.account_number &&
                  formik.errors.account_number && (
                    <div className="error">{formik.errors.account_number}</div>
                  )}
              </div>
            </div>
            <div>
              <div className="match-lableName">IFSC Code</div>
              <div className="matchTextbox">
                <input
                  type="text"
                  name="ifsc_code"
                  onChange={formik.handleChange}
                  value={formik.values.ifsc_code}
                />
              </div>
            </div>
            <div>
              <div className="match-lableName">Bank Name</div>
              <div className="matchTextbox">
                {/* <input
                  type="text"
                  name="bank"
                  onChange={formik.handleChange}
                  value={formik.values.bank}
                /> */}
                <select
                  name="bank"
                  onChange={formik.handleChange}
                  value={formik.values.bank}
                >
                  <option value="">Select Bank</option>
                  <option value="Union Bank of India">
                    Union Bank of India
                  </option>
                  <option value="UCO Bank">UCO Bank</option>
                  <option value="State Bank of India">
                    State Bank of India
                  </option>
                  <option value="Punjab National Bank">
                    Punjab National Bank
                  </option>
                  <option value="Canara Bank">Canara Bank</option>
                  <option value="Bank of Maharashtra">
                    Bank of Maharashtra
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className="btnBasicSave">
            <Button type="submit" disabled={loader}>
              {loader ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </div>
      </form>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose} //close modal on background click
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img srcSet={successImg} />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
              >
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                The profile has been successfully updated
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </div>
  );
}
